/* eslint-disable */
import { Calendar, CalendarValueType, CalendarMultipleValueType, CalendarInput, CalendarSelector, ICalendarItem, useDictionary, useParameter, ICalendarInputComponentProps, ICalendarSelectorComponentProps } from '../../shared';
import React from 'react';
import { Input } from './components/Input';
import { Selector } from './components/Selector';
import { dictionaryService } from '../../dataFlow';
import { CalendarBASFPropsType } from './types';
import Skeleton, { SkeletonProps } from '@material-ui/lab/Skeleton';
import { useInputProps } from './hooks/useInputProps';
import { uniq } from '../../../../shared';

// TODO: Вынести логику в хуки, чтоб не усложняи читаемость
export const CalendarBASF: React.FC<CalendarBASFPropsType> = props => {
  const { isDeep = false, multiple, items, parameter, selectorMask, value: propsValue } = props;
  const [stateItems, setStateItems] = React.useState(props.items);
  const [parameterValue, setParameterValue] = useParameter<unknown | unknown[]>(parameter);
  const [calendarValueDefault, setCalendarValueDefault] = React.useState<unknown | undefined>(undefined);
  const [calendarValue, setCalendarValue] = React.useState<unknown | undefined>(undefined);
  const [deepLevelDefault, setDeepLevelDefault] = React.useState<unknown>(undefined);
  const [deepLevel, setDeepLevel] = React.useState<unknown>(undefined);
  const [ignoreSelectorMask, setIgnoreSelectorMask] = React.useState<boolean>(false);
  const [ignoreChange, setIgnoreChange] = React.useState<boolean>(false);

  const disabledDeepLvl = isDeep && (deepLevel || deepLevelDefault) !== deepLevelDefault;
  
  React.useEffect(() => {
    setStateItems(items);
  }, [JSON.stringify(items)]);

  React.useEffect(() => {
    // Эффект инициализации
    if (items) {
      const normolizedPropValue = propsValue ? (Array.isArray(propsValue) ? propsValue.map(String) : `${propsValue}`) : null;
      let value: CalendarMultipleValueType | CalendarValueType = normolizedPropValue || null;
      const resultParamValue = props.onSet ? props.onSet(parameterValue) : parameterValue;
      if (parameterValue) {
        const numbersVal = resultParamValue as number[];
        const numberVal = resultParamValue as number;
        value = props.multiple ? numbersVal.map(String) : String(numberVal);
      }
      setCalendarValue(value);
      setCalendarValueDefault(value);
      // setIgnoreSelectorMask(false);
    }
  }, [parameterValue, propsValue, items]);

  React.useEffect(() => {
    // Эффект, от переключения значения локального.  наблюдает за включением глубокого режима
    if (isDeep) {
      if (items && calendarValue) {
        if (!multiple) {
          const candidateItem = items.find(x => String(x.id) === String(calendarValue));
          const candidateLevel = String(candidateItem?.frequency);
          setStateItems(items.filter(x => String(x.frequency) === candidateLevel));
          if (deepLevelDefault === undefined) {
            setDeepLevelDefault(candidateLevel);
          }
        }
        else if ((calendarValue as unknown[]).length) {
          const calendarValues = (calendarValue as unknown[]).map(val => String(val));
          const candidatesItems = items.filter(x => calendarValues.includes(String(x.id)));
          const frequencies = uniq(candidatesItems.map(item => item.frequency));
          const candidateLevel = String(frequencies[0]);
          setStateItems(items.filter(x => String(x.frequency) === candidateLevel));
          if (deepLevelDefault === undefined) {
            setDeepLevelDefault(candidateLevel);
          }
        }
      }
    } else {
      setIgnoreSelectorMask(false);
      setDeepLevelDefault(undefined);
      setDeepLevel(undefined);
      setStateItems(items);
    }
  }, [isDeep, multiple, items, calendarValue, deepLevelDefault]);

  React.useEffect(() => {
    // Второстепенный эфект, который оказывает глубокий режим
    if (isDeep && deepLevelDefault && deepLevel) {
      setIgnoreSelectorMask(deepLevelDefault !== deepLevel);
    }
  }, [isDeep, deepLevelDefault, deepLevel]);

  const handleOnClickLevel = React.useCallback(() => {
    if (isDeep && items && calendarValue) {
      if (!multiple) {
        const candidate = items.find(x => String(x.id) === String(calendarValue));
        if (candidate) {
          const candidateParent = items.find(x => String(x.id) === String(candidate.parent));
          if (candidateParent) {
            setIgnoreChange(true);
            setCalendarValue(String(candidateParent.id));
            setDeepLevel(String(candidateParent.frequency));
          }
        }
      } else {
        const calendarValues = (calendarValue as unknown[]).map(val => String(val));
        const candidatesItems = items.filter(x => calendarValues.includes(String(x.id)));
        const candidatesParentsIds = candidatesItems.map(item => item.parent);
        const candidatesParents = items.filter(x => candidatesParentsIds.includes(String(x.id)));
        if (candidatesParents.length) {
          setIgnoreChange(true);
          setCalendarValue(candidatesParentsIds);
          const frequencies = uniq(candidatesParents.map(item => item.frequency));
          const parentLevel = String(frequencies[0]);
          setDeepLevel(parentLevel);
        }
      }
    }
  }, [isDeep, deepLevel, calendarValue]);

  const handleOnChangeValue = React.useCallback((nextValue: CalendarMultipleValueType | CalendarValueType) => {
    if (!ignoreChange) {
      if (multiple) {
        if (JSON.stringify(calendarValue) !== JSON.stringify(nextValue)) {
          const numberValues = nextValue ? (nextValue as any[]).map(Number) : null;
          if (!disabledDeepLvl) {
            if (parameter) {
              setCalendarValue((props.onChange ? props.onChange(numberValues) : numberValues));
              setParameterValue((props.onChange ? props.onChange(numberValues) : numberValues));
            } else if (props.onChange) {
              props.onChange(numberValues);
            }
          } else {
            const candidatesChildren = items!.filter(x => numberValues?.includes(Number(x.parent)));
            setCalendarValue(candidatesChildren.map(x => Number(x.id)));
            setDeepLevel(String(candidatesChildren[0]?.frequency));
          }
        }
      } else {
        if (String(calendarValue)) {
          const numberValue = nextValue ? Number(nextValue) : null;
          if (!disabledDeepLvl) {
            if (parameter) {
              setCalendarValue(props.onChange ? props.onChange(numberValue) : numberValue);
              setParameterValue(props.onChange ? props.onChange(numberValue) : numberValue);
            } else if (props.onChange) {
              props.onChange(numberValue);
            }
          } else {
            const nextCandidate = items?.find(x => numberValue === Number(x.id));
            if (nextCandidate && String(nextCandidate.frequency) === String(deepLevel)) {
              const candidateChild = items?.find(x => numberValue === Number(x.parent));
              if (candidateChild) {
                setIgnoreChange(true);
                setCalendarValue(Number(candidateChild.id));
              }
              setDeepLevel(String(candidateChild?.frequency || deepLevelDefault));
            }
          }
        }
      }
    } else {
      setIgnoreChange(false);
    }
  }, [isDeep, deepLevel, calendarValue, parameter, ignoreChange]);

  const handleOnSelect = React.useCallback((nextValue: CalendarMultipleValueType | CalendarValueType) => {
    if (multiple && disabledDeepLvl && items) {
      const currentValue = (calendarValue as string[]).map(Number);
      let multipleValue = (nextValue as CalendarMultipleValueType)?.map(Number).concat(currentValue);
      if (multipleValue) {
        multipleValue = uniq(multipleValue);
      }
      const candidatesChildren = items.filter(x => multipleValue?.includes(Number(x.parent)));
      if (candidatesChildren.length) {
        setCalendarValue(candidatesChildren.map(x => Number(x.id)));
        setDeepLevel(String(candidatesChildren[0]?.frequency));
      } else {
        setCalendarValue(multipleValue);
        setDeepLevel(String(deepLevelDefault));
      }
    }
  }, [disabledDeepLvl, multiple, calendarValue]);

  const handleOnCancel = React.useCallback(() => {
    setCalendarValue(calendarValueDefault);
    setDeepLevel(deepLevelDefault);
  }, [calendarValueDefault]);

  const [inputProps, inputRef] = useInputProps(props, handleOnChangeValue);
  const itemsKey = React.useMemo(() => JSON.stringify(props.items), [props.items]);

  const selectorProps = React.useMemo(() => {
    const result = ({
      inputRef,
      selectorMask: ignoreSelectorMask ? undefined : selectorMask,
      groupMask: props.groupMask,
      onClickGroup: handleOnClickLevel, onCancel: handleOnCancel,
      onChange: handleOnChangeValue,
      closeOnSelect: !isDeep || (deepLevel || deepLevelDefault) === deepLevelDefault,
      disableApplay: disabledDeepLvl,
      onSelect: handleOnSelect,
    });
    return result;
  },
    [inputRef, inputProps, isDeep, deepLevel, deepLevelDefault, ignoreSelectorMask, disabledDeepLvl, selectorMask, handleOnClickLevel, handleOnCancel, handleOnChangeValue]
  );

  return React.useMemo(() => {
    if (!props.items) {
      return <Skeleton variant="rect" width="168px" height="51px" />
    }
    return (
      <Calendar multiple={props.multiple} groupSize={12} fillBlanks={props.fillBlanks} items={stateItems} value={calendarValue as any} groupMask={props.groupMask}>
        <CalendarInput component={Input as React.FC<ICalendarInputComponentProps>} props={inputProps} />
        <CalendarSelector component={Selector as React.ComponentType<ICalendarSelectorComponentProps>} props={selectorProps} />
      </Calendar>
    );
  }, [itemsKey, inputProps, selectorProps, calendarValue, stateItems, ignoreChange]);
}